export const getBillDiscount = (bill = "", total = "") => {
  let billDiscount;

  if (bill.discount_type == "price") {
    billDiscount = bill.discount ? parseInt(bill.discount) : 0;
  } else {
    if (bill.discount) {
      let first = total / 100;
      let second = bill.discount;
      let temps = parseInt(first * second);
      billDiscount = temps;
    } else {
      billDiscount = 0;
    }
  }

  return { billDiscount: billDiscount };
};
